<template>
  <div class="contenedor-selectores" :class="{ 'es-movil': esMovil }">
    <Selector
      ref="selector_sector"
      id="selector_sector"
      :lista="require('@/assets/data/diccionarios/lista_sectores.json')"
      :formato_items="(it) => it.sector"
      :placeholder="esMovil ? 'Sector' : 'Seleccionar sector'"
      texto_limpiar="Todos los sectores"
      @alCambiar="(it) => cambiarCvesSector(it.map((i) => i.id_sector))"
    />

    <Selector
      ref="selector_pais"
      id="selector_pais"
      :lista="require('@/assets/data/diccionarios/lista_paises.json')"
      :formato_items="(it) => it.pais"
      :placeholder="esMovil ? 'País' : 'Seleccionar país'"
      texto_limpiar="Todos los países"
      @alCambiar="(it) => cambiarCvesPais(it.map((i) => i.codigo_pais))"
    />

    <Selector
      ref="selector_estatal"
      id="selector_estatal"
      :style="{ display: selectorEstatalVisible ? 'block' : 'none' }"
      :lista="require('@/assets/data/diccionarios/lista_estados.json')"
      :formato_items="([, estado]) => estado"
      :placeholder="esMovil ? 'Estado' : 'Seleccionar estado'"
      @alCambiar="(it) => cambiarCvesEdo(it.map(([cve]) => cve))"
    />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import Selector from "@/components/utiles/Selector";
import { idMexico } from "@/components/mapas/utiles";

export default {
  methods: {
    ...mapMutations("mapaActores", ["resetearExtensionMapa"]),
    ...mapActions("mapaActores", [
      "cambiarCvesSector",
      "cambiarCvesPais",
      "cambiarCvesEdo",
    ]),
  },
  watch: {
    actualCvePais(newVal) {
      if (newVal === undefined) {
        // no hay selección por país
        this.$refs.selector_pais.limpiarSeleccion();
        //console.log("resetear selección países");
        this.resetearExtensionMapa();
      } else {
        this.$refs.selector_pais.addSeleccionPorFiltro(
          (pais) => pais.codigo_pais === newVal
        );
      }
    },
    actualCveEdo(newVal) {
      if (newVal === undefined) {
        // no hay selección estatal
        // console.log("resetear selección estatal");
        this.$refs.selector_estatal.limpiarSeleccion();
      } else {
        // console.log("seleccionar méxico al selector pais");
        this.$refs.selector_pais.addSeleccionPorFiltro(
          (pais) => pais.codigo_pais === idMexico
        );
        this.$refs.selector_estatal.addSeleccionPorFiltro(
          ([cveent]) => cveent === newVal
        );
      }
    },
  },
  computed: {
    ...mapGetters("mapaActores", ["actualCvePais", "actualCveEdo"]),
    esMovil() {
      return Boolean(window.innerWidth < 769);
    },
    selectorEstatalVisible() {
      return Boolean(this.actualCvePais === idMexico);
    },
  },
  components: {
    Selector,
  },
};
</script>

<style lang="scss">
.contenedor-selectores {
  $web: map-get($media-queries-limit, "mobile") + 1;
  $movil: map-get($media-queries-limit, "mobile");

  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;

  .dai-selector {
    .placeholder-selector {
      font-weight: normal;
    }

    &.lista-abierta {
      @media (max-width: $movil) {
        position: absolute;
        width: calc(100% - 80px);
        left: 40px;
        right: 40px;
      }
    }
  }
}
</style>
